

class CartPage {
  constructor(parent) {
    this.parent = parent;
    if (!this.parent) {
      return;
    }
    this.init();
  }
  clickEvents = () => {
    const parent = this.parent;
    const couponContent = parent?.querySelector(".coupon-content");
    const couponToggle = parent?.querySelector(".coupon-toggle");
    const qntSelects = parent?.querySelectorAll(".quantity-selector");
    couponToggle && couponToggle.addEventListener("click", () => {
      couponContent && couponContent.classList.toggle("collapsed");
      couponToggle && couponToggle.classList.toggle("open");
    })
    
    qntSelects && qntSelects.forEach(qntSelect => {
      qntSelect && qntSelect.addEventListener("change",(e)=>{
        const tableParent = e.target.closest(".cart-item");
        const input = tableParent?.querySelector(".quantity__input");
        if(input){
          input.value = Number(e.target.value);
          input.dispatchEvent(new Event('change'));
        }
      })
    });
  }
  updateCart = async (noCode = false) => {
    const cart = await fetch("/cart");
    const response = await cart.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(response, 'text/html');

    let oldCouponCode = document.querySelector(".coupon-code");
    let newCouponCode = doc.querySelector(".coupon-code");
    if(oldCouponCode && newCouponCode && !noCode){
      oldCouponCode.innerHTML = newCouponCode.innerHTML;
      const couponToggle = oldCouponCode?.querySelector(".coupon-toggle");
      this.clickEvents();
      couponToggle && couponToggle.click();
    }

    let oldSummary = document.querySelector(".cartTotal");
    let newSummary = doc.querySelector(".cartTotal");
    if(oldSummary && newSummary){
      oldSummary.innerHTML = newSummary.innerHTML;
      this.setCartDiscount();
    }
  }
  setCartDiscount=()=>{
    const cartDiscount = document.querySelector('[data-update-coupon]');
    const removeCode = document.querySelector(".coupon-remove");
    cartDiscount && cartDiscount.addEventListener("click", async (e) => {
      const parent = document.querySelector(".coupon-content-inner");
      const errorContainer = document.querySelector(".error-message-coupon-code");
      
      if(parent){
        let input = parent.querySelector(".input");
        if(input){
          const couponCode = input.value.trim();
          if(couponCode.length > 0){
            cartDiscount.classList.add("loading");
            if(cartDiscount.getAttribute("data-applied-code")?.length > 0){
              const errorAlreadyContainer = document.querySelector(".error-message-coupon-code.already");
              errorAlreadyContainer.innerHTML = `We're sorry, it appears you've already redeemed code: "MEM20".`;
              errorAlreadyContainer.classList.remove("hide");
              input.value = "";
              setTimeout(()=>{
                cartDiscount.classList.remove("loading");
              },800)
              return;
            }
            try {
              const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ discount: couponCode })
              });
              const data = await response.json();
              const validCodes = data.discount_codes.filter(code => code.applicable);
              if(validCodes?.length > 0){
                this.updateCart();
              }else {
                errorContainer.innerHTML = `Promo Code "${couponCode}" is not valid.`;
                errorContainer.classList.remove("hide");
                input.value = "";
                this.updateCart(true);
              }
            } catch (error) {
              console.error('Error:', error);
            } finally{
              cartDiscount.classList.remove("loading");
            }
          }
        }
      }
    })  
    removeCode && removeCode.addEventListener("click", async (e) => {
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ discount: "" })
      });
      const data = await response.json();
      if(data?.discount_codes?.length == 0){
        this.updateCart();
      }
    })
  }
  init = () => {
    this.clickEvents();
    this.setCartDiscount();
  }
}

setTimeout(() => {
  const drawer = document.querySelector(".cart-page");
  if (drawer) {
    new CartPage(drawer);
  }
}, 500)